import { render } from "./jassa_show.vue?vue&type=template&id=69767c5a&scoped=true"
import script from "./jassa_show.vue?vue&type=script&lang=js"
export * from "./jassa_show.vue?vue&type=script&lang=js"

import "./css/common.scss?vue&type=style&index=0&id=69767c5a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69767c5a"]])

export default __exports__